import Vue from 'vue'
import VueResource from 'vue-resource'
import router from '../router'
import * as types from '../store/mutation-types'
Vue.use(VueResource)
Vue.http.options.emulateJSON = true
export const apiActions = {
  getActInfo: {// 判断活动状态
    url: './faker/activity',
    method: 'GET'
  },
  WX_INIT: {// 微信卡片样式
    url: './api/openstore/getJsConfig',
    method: 'POST'
  },
  payFairAction: {// 新增小富市集订单支付接口
    url: './api/openstore/muti_pay_create',
    method: 'POST'
  },
  getCartNum: {// 获取购物车商品数量
    url: './api/openstore/get_cart_num',
    method: 'POST'
  },
  getFairCartGoods: {// 获取购物车
    url: './api/openstore/muti_store_cart_list',
    method: 'POST'
  },
  LOGIN: {// 登录
    url: './api/community/account/quickLogin',
    method: 'POST'
  },
  SEND_VERIFY_SMS: {// 获取登录验证码
    url: './api/community/account/sendQuickLoginSms',
    method: 'POST'
  },
  getFairDetai: { // 小富市集详情接口
    url: './api/openstore/xfsj/get_activity_info',
    method: 'POST'
  },
  getDiscountDetail: {// 周边商家-优惠券详情
    url: './api/openstore/coupon/get_open_store_coupon',
    method: 'POST'
  },
  getServiceDetail: {// 根据serviceId获取具体的模板接口
    url: './api/openstore/get_open_service_detail',
    method: 'POST'
  },
  getPriceInfo: {// 获取实时的运费跟商品价格接口
    url: './api/openstore/good_list_before_pay',
    method: 'POST'
  },
  getGoodDetail: {// 获取商品详情接口
    url: './api/openstore/good_get_detail',
    method: 'POST'
  },
  getPersonalInfo: {// 获取用户信息接口
    url: './api/openstore/get_user_info',
    method: 'POST'
  },
  getOrderList: {// 获取用户订单列表接口
    url: './api/openstore/order_list',
    method: 'POST'
  },
  getOrderListCount: {
    url: './api/openstore/order_list_count',
    method: 'POST'
  },
  getQuickOrderList: {// 获取闪付订单列表接口
    url: './api/openstore/open_quick_order_pager',
    method: 'POST'
  },
  getQuickOrderDetail: {// 获取单个闪付订单详情接口
    url: './api/openstore/get_open_quick_order',
    method: 'POST'
  },
  getConfirmOrderDetail: {// 确认订单页面获取数据
    url: './api/openstore/muti_data_before_pay',
    method: 'POST'
  },
  confirmReceive: {// 确认收货接口
    url: './api/openstore/order_confirm_receive',
    method: 'POST'
  },
  getOrderDetail: {// 获取订单信息接口
    url: './api/openstore/order_get_detail',
    method: 'POST'
  },
  getOrderDetail2: {// 获取订单信息接口2
    url: './api/openstore/order_get_pay_detail',
    method: 'POST'
  },
  getOrderBillDetail: {
    url: './api/openstore/order_get_center_bill_detail',
    method: 'POST'
  },
  getPosEnable: {
    url: './api/openstore/conf/canUserPos',
    method: 'POST'
  },
  addToCar: {// 加入购物车接口
    url: './api/openstore/cart_add',
    method: 'POST'
  },
  updateCartSku: { // 购物车中更新商品规格
    url: './api/openstore/cart_update_sku',
    method: 'POST'
  },
  minusFromCar: {// 减少购物车数量接口
    url: './api/openstore/cart_reduce',
    method: 'POST'
  },
  deleteFromCar: {// 删除购物车商品接口
    url: './api/openstore/cart_delete',
    method: 'POST'
  },
  getStoreInfo: {// 商店首页
    url: './api/openstore/get_store_templete_info',
    method: 'POST'
  },
  quickOrderCreate: { // 创建闪付订单
    url: './api/openstore/quick_order_create',
    method: 'POST'
  },
  quickOrderPayCreate: { // 支付闪付订单
    url: './api/openstore/quick_order_pay_create',
    method: 'POST'
  },
  candleQuickOrderId: {
    url: './api/openstore/cancel_open_quick_order',
    method: 'POST'
  },
  deleteQuickOrder: {
    url: './api/openstore/delete_quick_order',
    method: 'POST'
  },
  getStoreCouponList: { // 获取店铺优惠券列表
    url: './api/openstore/open_store_coupon_list',
    method: 'POST'
  },
  getValidCouponList: { // 获取闪付优惠券列表
    url: './api/openstore/get_valid_coupon_record',
    method: 'POST'
  },
  getStoreServiceDiscount: { // 获取闪付满减优惠信息
    url: './api/openstore/getStoreServiceDiscount',
    method: 'POST'
  },
  pickCoupon: { // 领取优惠券
    url: './api/openstore/receive_store_coupon_record',
    method: 'POST'
  },
  getXFSJServiceDetail: {// 商店首页
    url: './api/openstore/getXFSJServiceDetail',
    method: 'POST'
  },
  getAllDiscount: {// 周边商家模板首页
    url: './api/openstore/coupon/list_open_store_coupon',
    method: 'POST'
  },
  getGoodsDetail: {// 获取商品详情接口
    url: './api/openstore/good_get_detail',
    method: 'POST'
  },
  getGoodsList: {// 获取商品列表
    url: './api/openstore/good_page_query',
    method: 'POST'
  },
  getGroupDataList: {// 获取团购列表
    url: './api/openstore/groupdata/getGroupDataList',
    method: 'POST'
  },
  getGroupDetail: {// 获取团购详情
    url: './api/openstore/groupdata/getDetail',
    method: 'POST'
  },
  setcartNum: {// 购物车数量接口
    url: './api/openstore/cart_set_amount',
    method: 'POST'
  },
  createStoresOrder: {//
    url: './api/openstore/muti_order_create',
    method: 'POST'
  },
  createOrder: { // 新增订单接口
    url: './api/openstore/order_create',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  },
  getCommList: {
    url: './api/openstore/getXFSJCommunity',
    method: 'POST'
  },
  getCityList: {
    url: './api/openstore/group_area_list',
    method: 'GET'
  },
  getCommunityListByCityId: {
    url: './api/openstore/getCommunityListByCityId',
    method: 'POST'
  },
  checkServiceComm: {
    url: './api/openstore/canUseThisCommunity',
    method: 'POST'
  },
  clientTicket: {// 获取临时令牌
    url: './api/openstore/client_ticket',
    method: 'POST'
  },
  getStoreList: {
    url: './api/openstore/searchService',
    method: 'POST'
  },
  getGoodList: {
    url: './api/openstore/searchGoods',
    method: 'POST'
  },
  getSearchBaseInfo: { // 获取筛选项
    url: './api/openstore/getSearchBaseInfo',
    method: 'POST'
  },
  getSreachHistoryList: { // 获取搜索历史列表
    url: './api/openstore/userSearchLogs',
    method: 'POST'
  },
  delSreachHistoryList: { // 删除搜索
    url: './api/openstore/delUserSearchLogs',
    method: 'POST'
  },
  clearSreachHistoryList: { // 清除搜索
    url: './api/openstore/cleanUserSearchLogs',
    method: 'POST'
  },
  listGoodsCategory: {
    url: './api/openstore/listGoodsCategory',
    method: 'POST'
  },
  getListOptimizing: {
    url: './api/openstore/list_order_three_by_my',
    method: 'POST'
  },
  listGoodsInfoByCategory: {
    url: './api/openstore/listGoodsInfoByCategory',
    method: 'POST'
  },
  getCommunityInfo: {// 获取用户信息 rf_open_id
    // "id": "111",      //社区ID
    // "name": "haha",         //社区名称
    // "address": "广州富力中心" //社区地址
    // "area_name":"中国-广东省-广州市-天河区",   //区域名称
    // "intro":"3223",            //社区简介
    // "logo_url":"http://3209293.com"
    url: './api/openstore/community_info',
    method: 'POST'
  },
  getDefaultAddressList: { // 获取默认地址管理
    url: './api/openstore/address_manage_list',
    method: 'POST'
  },
  getAddressList: { // 获取认证地址列表
    url: './api/openstore/address_manage_auth_list',
    method: 'POST'
  },
  addAddress: { // 新增地址
    url: './api/openstore/address_manage_insert',
    method: 'POST'
  },
  editAddress: { // 编辑地址
    url: './api/openstore/address_manage_modify',
    method: 'POST'
  },
  setDefaultAddress: { // 设置默认地址
    url: './api/openstore/address_manage_set_default',
    method: 'POST'
  },
  getConfirmAddress: { // 获取确认订单地址
    url: './api/openstore/get_defalut_address_manage',
    method: 'POST'
  },
  delAddress: { // 删除地址
    url: './api/openstore/address_manage_delete',
    method: 'POST'
  },
  getAreaList: { // 获取地区列表
    url: './api/openstore/get_area_list',
    method: 'POST'
  },
  getRefundDetail: { // 获取退款详情
    url: './api/openstore/get_refund_detail',
    method: 'POST'
  },
  applyRefund: { // 申请售后
    url: './api/openstore/refund_apply',
    method: 'POST'
  },
  getActivity: {
    url: './api/openstore/platform/get_activity_info',
    method: 'POST'
  },
  getOperatorActivity: {
    url: './api/openstore/getOperatorActivityDetail',
    method: 'POST'
  },
  uploadImage: { // 上传后台图片接口
    url: './api/openstore/upload_image',
    method: 'POST'
  },
  uploadBase64Img: { // 上传base64后台图片接口
    url: './api/openstore/uploadBase64Img',
    method: 'POST'
  },
  getExpressAuthoerizeUrl: { // 获取待令牌的地址
    url: './api/openstore/getExpressAuthorizeUrl',
    method: 'POST'
  },
  getExpressInfo: { // 通过快递单号查询快递信息
    url: './api/openstore/getExpressInfo',
    method: 'POST'
  },
  getServiceHomePage: { // 店铺首页
    url: './api/openstore/getServiceHomePage',
    method: 'POST'
  },
  getCategoryList: { // 商品编辑时选择启用的分类列表
    url: './api/openstore/categoryList',
    method: 'POST'
  },
  getCommentList: {
    url: './api/openstore/comment_get',
    method: 'POST'
  },
  addComment: {
    url: './api/openstore/comment_add',
    method: 'POST'
  },
  getCommentInfo: {
    url: './api/openstore/getOrderGoodsInfo',
    method: 'POST'
  },
  getWeChatInfo: { // 获取微信配置
    url: './api/openstore/weixin/getWXJsConfig',
    method: 'POST'
  },
  validateToken: { // 校验token
    url: './api/openstore/validateToken',
    method: 'POST'
  },
  getZMCallbackInfo: {
    url: './api/openstore/get_zm_callback_info',
    method: 'POST'
  },
  deductCouponList: { // 获取抵用券汇总列表
    url: './api/openstore/deduct_coupon_list',
    method: 'POST'
  },
  getCouponConfirmQrcode: { // 获取二维码
    url: './api/openstore/get_coupon_confirm_qrcode',
    method: 'POST'
  },
  getStoreDeductCouponList: { // 获取门店信息抵用券列表
    url: './api/openstore/store_deduct_coupon_list',
    method: 'POST'
  },
  openStoreCouponDetail: { // 获取抵用券详情页
    url: './api/openstore/open_store_coupon_detail',
    method: 'POST'
  },
  createCouponOrder: { // 抵用券创建订单
    url: './api/openstore/coupon_order_create',
    method: 'POST'
  },
  payCouponOrder: { // 支付抵用券订单
    url: './api/openstore/coupon_order_pay',
    method: 'POST'
  },
  getUserCouponList: { // 获取用户抵用券列表
    url: './api/openstore/user_deduct_coupon_list',
    method: 'POST'
  },
  getUserCouponDetail: { // 获取单个抵用详情接口
    url: './api/openstore/user_deduct_coupon_detail',
    method: 'POST'
  },
  getCustomerServicePhone: { // 获取电话客服
    url: './api/openstore/get_customer_service_phone',
    method: 'POST'
  },
  getActivityAd: { // 获取活动图片链接
    url: './api/openstore/get_activity_ad',
    method: 'POST'
  },
  getSkuGoods: { // 获取sku 信息接口
    url: './api/openstore/goods_get_simple_detail',
    method: 'POST'
  },
  checkAreaServiceRela: { // 判断是否服务范围内
    url: './api/openstore/check_area_service_rela',
    method: 'POST'
  },
  validateCartGoods: {
    url: './api/openstore/validateCartGoods',
    method: 'POST'
  },
  cancelOrderShop: {
    url: './api/openstore/cancel_order',
    method: 'POST'
  },
  delOrderShop: {
    url: './api/openstore/delete_order',
    method: 'POST'
  },
  getBusinessShoppingStatus: { // 根据订单id,查询该订单是否需要显示企业购支付方式
    url: './api/openstore/getBusinessShoppingStatus',
    method: 'POST'
  },
  getThinkinpowerBankInfo: { // 获取思力银行卡信息
    url: './api/openstore/get_thinkinpower_bank_info',
    method: 'POST'
  },
  getStationDetail: {
    url: './api/openstore/station/detail/{communityId}/',
    method: 'POST'
  },
  getToolRentalDetail: {
    url: './api/openstore/station/leaseTool/{communityId}/',
    method: 'POST'
  },
  getSmallAd: { // 广告位
    url: './api/community/ad/getSmallAd',
    method: 'POST'
  },
  getOpenPayBonusPoint: { // 获取积分的接口
    url: './api/openstore/getOpenPayBonusPoint',
    method: 'POST'
  },
  // 获取分销推广详情
  getPopularizePlanDetail: {
    url: './api/openstore/getPopularizePlanDetail',
    method: 'POST'
  },
  // 去平台验证是否该用户已经开通了钱包，返回钱包信息
  queryWalletInfoByUid: {
    url: './api/openstore/queryWalletInfoByUid',
    method: 'POST'
  },
  // 创建已注册个人钱包的匿名商家支付信息
  createAnonyMchPayInfo: {
    url: './api/openstore/createAnonyMchPayInfo',
    method: 'POST'
  },
  // 钱包跳转地址
  walletRedirectUrl: {
    url: './api/openstore/v2/sendRedirect',
    method: 'POST'
  },
  // 代扣协议跳转地址
  deductContractUrl: {
    url: './api/openstore/v2/deductContractUrl',
    method: 'POST'
  },
  // 查询社区所有物业的楼层信息
  listFloorInfoByCommunity: {
    url: './api/openstore/listFloorInfoByCommunity',
    method: 'POST'
  },
  // 查询所有富力项目的城市社区
  listCityByCommunity: {
    url: './api/openstore/city_by_community',
    method: 'POST'
  },
  // 查询用户的APP默认社区
  userDefaultCommunity: {
    url: './api/openstore/userDefaultCommunity',
    method: 'POST'
  },
  // 申请开票
  addOrderTaxLog: {
    url: './api/openstore/addOrderTaxLog',
    method: 'POST'
  },
  // 查询发票详情
  getTaxInfoByOrderId: {
    url: './api/openstore/getTaxInfoByOrderId',
    method: 'POST'
  },
  listMoneyType: {
    url: './api/openstore/listMoneyType',
    method: 'POST'
  },
  getOrderDetailInfo: {
    url: './api/openstore/getOrderDetailInfo',
    method: 'POST'
  },
  getOrderStatus: {
    url: './api/openstore/getOrderStatus',
    method: 'POST'
  },
  getOrderQrcode: {
    url: './api/openstore/getOrderQrcode',
    method: 'POST'
  },
  // 标普云注册短信通知
  tunnelRegister: {
    url: './api/openstore/tunnelRegister',
    method: 'POST'
  },
  // 获取富邻频道页内容
  getMiniInfoListByCommunity: {
    url: './api/openstore/getMiniInfoListByCommunity',
    method: 'POST'
  },
  // 获取社区服务店铺列表
  getCommunityServiceStoreList: {
    url: './api/openstore/getCommunityServiceStoreList',
    method: 'POST'
  },
  // 分页获取商品排行榜列表
  getGoodRankListByPage: {
    url: './api/openstore/getGoodRankListByPage',
    method: 'POST'
  },
  // 获取商品对应的用户需求配置
  getGoodsNeeds: {
    url: './api/openstore/before_pay_good_needs',
    method: 'POST'
  },
  bindPopularizeUser: {
    url: './api/openstore/bindPopularizeUser',
    method: 'POST'
  },
  getRecentlyCommunity: {
    url: './api/openstore/getRecentlyCommunity', // 获取社区
    method: 'POST'
  }
}
Vue.resource.actions = apiActions// 使用自定义的vue-resource action
// Vue.http.headers.common['ApiEnv'] = 'testextra'

// 使用vue-resource调用接口
export const webService = ({ dispatch, commit, apiAction }, { restfulParams = {}, params = {}, apiOptions = {
  progress: (evt) => {
    if (evt.lengthComputable) {
      // var percentComplete = Math.round(evt.loaded * 100 / evt.total)
      // console.log(percentComplete + "%");
    }
  }
}, option = { showLoading: true } } = {}) => {
  commit(types.SET_API_TOGGLE_LOADING, { apiAction })// 将state中的状态设为加载中
  let ignoreIndicatorArr = ['getUserCouponDetail', 'getOrderDetail2', 'createStoresOrder']
  const showIndicator = ignoreIndicatorArr.indexOf(apiAction) === -1
  showIndicator && router.app.$indicator.open()
  let _params = apiActions[apiAction].method === 'POST' ? [restfulParams, params] : [Object.assign(params, restfulParams)]
  // console.log(_params)
  return new Promise((resolve, reject) => {
    Vue.resource(null, null, null, apiOptions)[apiAction](..._params)
      .then((response) => {
        // alert("response1:" + JSON.stringify(response))
        if (typeof response.data === 'string') {
          response.data = JSON.parse(response.data)
        }
        if (response.data.status === 200) {
          commit(types.SET_API_TOGGLE_SUCCESS, { apiAction })// 将state中的状态设为加载成功
          router.app.$indicator.close()
          commit(types.SET_API_DATA, { apiAction, data: response.data })// 将数据赋值到state
          resolve(response.data)
        } else if (response.data.status === 402 || response.data.status === 403) {
          let rectUrl = ''
          rectUrl = window.location.href
          localStorage.setItem('backUrl', rectUrl)
          router.replace({ name: 'login', query: router.app.$route.query })
        } else if (response.data.status === 43011) {
          reject(response.data)
        } else {
          // let msg = apiAction + ':' + response.data.message + '(' + response.data.status + ')';
          // let msg = apiAction + ':' + response.data.message + '(' + response.data.status + ')';
          let msg = response.data.message
          let rectUrl = ''
          if (msg === '非法令牌' || msg === '验证失效，请重新进入' || msg === '令牌已过期') {
            msg = '请登录'
            // sessionStorage.setItem('backUrl', JSON.stringify({ name: router.history.current.name, params: router.history.current.params }))
            rectUrl = window.location.href
            localStorage.setItem('backUrl', rectUrl)
            // router.replace({ name: 'login', query: router.app.$route.query })
            dispatch('GO_TO_LOGIN_NOT_APP', rectUrl)
          }
          commit(types.SET_API_TOGGLE_FAIL, { apiAction })// 将state中的状态设为加载失败
          router.app.$indicator.close()
          commit(types.SET_API_DATA, { apiAction, data: response.data })// 将数据赋值到state
          if (response.data.status > 1000) {
            msg = ''
            if (response.data.status === 1020) {
              // html = createDialogHtml('priceEmpty');
              msg = 'token过期，请重新登录'
              let nextName = 'login'
              rectUrl = window.location.href
              localStorage.setItem('backUrl', rectUrl)
              router.replace({ name: nextName, query: router.app.$route.query })
            }
          } else {
            if (msg.match('用户未设置初始密码') != null) {
              msg = '请到自在社区app设置登录密码'
            }
          }
          if (!msg) {
            reject(response.data.message)
          } else {
            // router.app.$toast({ duration: 3000, message: msg })
            reject(msg)
          }

          // reject(response.data);f
        }
      })
      .catch((response) => {
        // console.log(response);
        // alert(JSON.stringify(response))
        let msg = ''
        if (response.status >= 0) {
          // msg = apiAction + ': (' + response.status + ')'
          if (response.status === 0) {
            // console.log(response)
            // msg = ''
            // router.app.$notify.error({duration:3000,title:'出错了',message:msg});
          } else if (response.status >= 200 && response.status < 400) {
          } else if (response.status === 503) {
            router.app.$toast({ duration: 3000, message: '活动太火爆了，系统繁忙，请稍后再试！' })
          }
        } else {
          if (Object.prototype.toString.call(response) === '[object Object]') {
            msg = apiAction + ': ' + JSON.stringify(response)
          } else {
            msg = apiAction + ': ' + response
          }
          // router.app.$notify.error({duration:3000,title:'出错了',message:msg});
        }
        commit(types.SET_API_TOGGLE_FAIL, { apiAction })// 将state中的状态设为加载失败
        router.app.$indicator.close()
        // if (msg) {
        //   router.app.$toast({ duration: 3000, message: msg })
        // }
        reject(msg)// 抛出错误信息
      })
  })
}

// function GetRedirectUrl () {
//   let [rectUrl, origin, pathname, search, hash] = ['', window.location.origin, window.location.pathname, window.location.search, window.location.hash]
//   search = search + `&isInit=1`
//   rectUrl = origin + pathname + search + hash
//   return rectUrl
// }
